import { Component, computed, inject, signal, ViewChild } from '@angular/core';
import { MAX_COMMENT_LENGTH } from '../../../../models/comment';
import { RatingDialogFacade } from 'src/app/_core/state/dialogs/rating/rating.facade';
import { toSignal } from '@angular/core/rxjs-interop';
import { TextareaComponent } from '../../forms/textarea/textarea.component';

@Component({
  selector: 'opac-rating-dialog',
  templateUrl: './rating-dialog.component.html',
  styleUrls: ['rating-dialog.component.scss'],
})
export class RatingDialogComponent {

  @ViewChild('descriptionTextarea') descriptionTextarea!: TextareaComponent;

  private readonly ratingDialogFacade = inject(RatingDialogFacade);

  readonly MAX_COMMENT_LENGTH = MAX_COMMENT_LENGTH;

  readonly isOpen = toSignal(this.ratingDialogFacade.open$);
  readonly userVote = toSignal(this.ratingDialogFacade.userVote$);
  readonly hasUserVoted = toSignal(this.ratingDialogFacade.hasUserVoted$);

  readonly userActionRequiredComputed = computed<boolean>(() => {
    return this.attemptedSubmit() && !this.rated() && !this.comment();
  });
  readonly attemptedSubmit = signal<boolean>(false);
  readonly rated = signal<boolean>(false);
  readonly comment = signal<string>('');
  readonly rating = signal<number>(0);
  readonly descriptionError = signal<string | null>(null);

  submit() {
    this.attemptedSubmit.set(true);

    if (this.userActionRequiredComputed()) {
      return;
    }

    if (this.descriptionError() !== null) {
      this.descriptionTextarea.focus();
      return;
    }

    if (this.comment()) {
      this.ratingDialogFacade.postComment(this.comment()).subscribe();
    }

    if (this.rated()) {
      this.ratingDialogFacade.postRating().subscribe();
    }

    this.closeDialog();
  }

  setRating(rate: number) {
    this.rating.set(rate);
    this.rated.set(true);
    this.ratingDialogFacade.setRating(rate);
  }

  setComment(comment: string) {
    this.comment.set(comment);

    if (comment.length > MAX_COMMENT_LENGTH) {
      this.descriptionError.set('textarea.charCountExceeded');
    } else {
      this.descriptionError.set(null);
    }
  }

  closeDialog() {
    this.attemptedSubmit.set(false);
    this.descriptionError.set(null);
    this.comment.set('');
    this.rated.set(false);
    this.rating.set(0);
    this.ratingDialogFacade.closeDialog();
  }
}
